export default {
    en: "English",
    sk: "Slovak"
}
